
export default function getTransactionStatus(status: string) {
    return status === 'A' ? 'Successful' :
        status === 'C' ? 'Cancelled' :
            status === 'D' ? 'Declined' :
                status === 'E' ? 'Error' :
                    status === 'X' ? 'Expired' :
                        'Unknown'
}